import React from "react";
import styled from "styled-components";
import { useFinaidYear } from "components/hooks/useFinaidYear";
import APILink from "components/ui/APILink";

export function LoanLinks() {
  const { awards: { loans: loanLinks } = {} } =
    useFinaidYear(({ finaidAwards }) => finaidAwards) || {};

  if (loanLinks.length > 0) {
    return (
      <LoanLinkStyles>
        {loanLinks.map((link, index) => (
          <APILink
            key={index}
            link={link}
            decoration={<i className="fa fa-arrow-right" />}
          />
        ))}
      </LoanLinkStyles>
    );
  }

  return null;
}

LoanLinks.displayName = "LoanLinks";

const LoanLinkStyles = styled.div`
  display: flex;
  gap: var(--lg);
  padding: var(--sm) var(--lg);
  font-weight: bold;
`;
